'use client';

import { useTranslation as _useTranslation } from '@crehana/i18n';

import { COMPONENT_KEY } from './constants';

export const useTranslation = () => {
  return _useTranslation(COMPONENT_KEY);
};
